import { render, staticRenderFns } from "./CenterPanel.vue?vue&type=template&id=f1c533be&scoped=true"
import script from "./CenterPanel.vue?vue&type=script&lang=js"
export * from "./CenterPanel.vue?vue&type=script&lang=js"
import style0 from "./CenterPanel.vue?vue&type=style&index=0&id=f1c533be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c533be",
  null
  
)

export default component.exports